const bootstrapSelect = require('bootstrap-select');

$(`.selectpickerCustom:not(.selectpicker)`).selectpicker();



if ($('.scoop').length) {

	$("<div id='stick-scoop-here'></div>").insertBefore(".scoop");

	function sticktothetop() {
		var window_top = $(window).scrollTop();
		var top = $('#stick-scoop-here').offset().top - $('.header').innerHeight();
		if (window_top > top) {
			$('.scoop').addClass('scoop_fixed').css({
				"top": $('.header').innerHeight(),


			});
			$('#stick-scoop-here').height($('.scoop').outerHeight());
		} else {
			$('.scoop').removeClass('scoop_fixed').css({
				"top": "0px"
				//             // "transition": "all .1s ease-in-out"
			});;
			$('#stick-scoop-here').height(0);
		}
	}
	$(function () {
		$(window).scroll(sticktothetop);
		sticktothetop();
	});

}






$(".accordion-wrapper .item .collapse").on("shown.bs.collapse", function (e) {
	let that = $(this);
	console.log('a')
	//to stop Scrolling on show add class no-scroll-on-show to body
	if (!$('body').hasClass("no-scroll-on-show")) {
		if ($('.targetOpened').length > 0) {
			$('.targetOpened').removeClass('targetOpened');
		}
		setTimeout(function () {

			var n = that.closest(".item");
			var head_height = n.find('.accordion-header').innerHeight() + 50;
			// if ($('.header').length > 0) {
			//     head_height = $('.header').innerHeight() + n.find('.accordion-header').innerHeight();
			// }
			let targetA = $(n).addClass('targetOpened');
			let target = document.querySelector('.targetOpened');
			window.scrollTobyMyscroll(target);

			// $("html,body").animate({
			//     //	scrollTop: n.offset().top - head_height - n.find('.accordion-header').innerHeight()
			//     scrollTop: n.offset().top - head_height
			// }, 300)
			window.UpdateMyScroll()

		}, 100)
	}
})



//menu
var lastScrollTop = 0;
const body = document.querySelector(".main-menu");
let pageY = 0;

const scrollUp = "scroll-up";
const scrollDown = "hide-on-scroll";
let lastScroll = 100;

function showHomeMenu() {
	let scrolled = 100;
	// if ($(window).width() < 768) {
	if ($(window).width() > 0) {

		scrolled = 0;
		//
		const currentScroll = window.pageYOffset;
		if (currentScroll == 100) {
			body.classList.remove(scrollUp);
			body.classList.remove(scrollUp);

			return;
		}

		if (currentScroll - 20 > lastScroll && !body.classList.contains(scrollDown)) {

			// down
			body.classList.remove(scrollUp);
			body.classList.add(scrollDown);
		} else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
			// up
			body.classList.remove(scrollDown);
			body.classList.add(scrollUp);



		}
		lastScroll = currentScroll;
		//

	}

	if ($(window).width() > 768) {
		$('.menuIcon  .hamburger').removeClass('is-active')
		$('.mainMenu').addClass('ishidden')
		$('html').removeClass('menuToggled noScroll')
	}
	if (pageY >= scrolled) {
		//showMainMenuItems()

	}


}
$(window).scroll(function (event) {

	if ($('.main-menuaa').length > 0) {


		var st = $(this).scrollTop();
		if (st > lastScrollTop) {
			// downscroll code
		} else {
			// upscroll code


			if ((st >= 0) && (st < 200)) {
				$(".header").removeClass('add-bg bg-white sticky-header');

			} else {

				$(".header").addClass('add-bg bg-white sticky-header');
			}



		}
		lastScrollTop = st;

		//mob-header
		pageY = window.pageYOffset;
		showHomeMenu();
	}
});



//menu

(function () {
	enableDisableCollapse()
	$(window).resize(function () {
		enableDisableCollapse()
	});
})();
if (window.innerWidth < 992) {
	$('.mainMenu .megamenu').addClass('mob-collapse collapse');
	//$('footer .collapse').addClass('mob-collapse')

}

function enableDisableCollapse() {
	if (window.innerWidth > 992) {
		//	$('footer .collapse').addClass('show');
		$('.mainMenu .megamenu').removeClass('mob-collapse collapse show').addClass('cccc dropdown-menu');
	} else {
		//	$('footer .collapse').not('.mob-collapse').removeClass('show');
		//$('.mainMenu .collapse').removeClass('show');
		$('.mainMenu .megamenu').not('.active').not('.mob-collapse').removeClass('dropdown-menu show').addClass('aaaa collapse');


	}
}
